// components/InfiniteScrollSentinel.tsx
import { onCleanup, onMount } from "solid-js";

export function InfiniteScrollSentinel(props: { onIntersect: () => void }) {
  let sentinelRef: HTMLDivElement | undefined;

  onMount(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        props.onIntersect();
      }
    }, { threshold: 0.1 });

    if (sentinelRef) observer.observe(sentinelRef);
    onCleanup(() => observer.disconnect());
  });

  return <div ref={sentinelRef} style={{ width: "1px", height: "100%" }} />;
}
